import LoadingScreen from "@components/LoadingScreen";
import {
  getAllVps,
  getVpsProfileById,
  VpsProfile,
} from "@redux/slices/strategicPlanning";
import { useEffect, useState } from "react";

const ReadmeVps = () => {
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState("");
  const [data, setData] = useState<VpsProfile>();

  useEffect(() => {
    setLoading(true);
    setId(window.location.pathname.split("/")[2]);
    getData();
  }, []);

  const getData = async () => {
    const data1 = await getVpsProfileById(
      Number(window.location.pathname.split("/")[2])
    );
    setData(data1);
    setLoading(false);
  };

  return (
    <div>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div className="px-80 pb-20 pt-5">
           <h4 className="text-xl font-medium mb-10 text-center">
           Value Propositions and Strengths (VPS)
          </h4>
          <h6 className="text-lg">
            1. What specific advantages does your product/service offer that
            your customers cannot find anywhere else?
          </h6>
          <p className="text-[#71717A] mb-4">{data?.question1}</p>
          <h6 className="text-lg">
            2. What are the top three reasons your customers chose your
            product/service?
          </h6>
          <p className="text-[#71717A] mb-4">{data?.question2}</p>
          <h6 className="text-lg">
            3. How do your products/services contribute to achieving your
            customers' strategic goals?
          </h6>
          <p className="text-[#71717A] mb-4">{data?.question3}</p>
          <h6 className="text-lg">
            4. What positive changes have your customers experienced by using
            your products/services?
          </h6>
          <p className="text-[#71717A] mb-4">{data?.question4}</p>
          <h6 className="text-lg">
            5. How would your customers describe the value they receive from
            your product/service?
          </h6>
          <p className="text-[#71717A] mb-4">{data?.question5}</p>
          <h6 className="text-lg">
            6. What problems or challenges did your customers face before using
            your solution, and how were these resolved by your product/service?
          </h6>
          <p className="text-[#71717A] mb-4">{data?.question6}</p>
          <h6 className="text-lg">
            7. How does your product/service stand out in terms of quality and
            performance compared to the competition?
          </h6>
          <p className="text-[#71717A] mb-4">{data?.question7}</p>
          <h6 className="text-lg">
            8. What aspects of your customer service or support are most
            appreciated by your customers?
          </h6>
          <p className="text-[#71717A] mb-4">{data?.question8}</p>
          <h6 className="text-lg">
            9. What future developments or improvements do you plan to further
            increase the value of your product/service?
          </h6>
          <p className="text-[#71717A] mb-4">{data?.question9}</p>
          <h6 className="text-lg">
            10. How do you communicate the benefits and advantages of your
            product/service to your potential and existing customers?
          </h6>
          <p className="text-[#71717A] mb-4">{data?.question10}</p>
        </div>
      )}
    </div>
  );
};

export default ReadmeVps;
